import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {LocationModel} from "../../../commons/models/location.model";
import {$agentFactory} from "../../$agent.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PollingIntervalRef, PollingIntervalService} from "../../../commons/services/polling-interval.service";

export class AgentLocationsViewCtrl implements IController {

  public searchQuery:string;
  private agentRef: any;
  private agentLocationRef: any;
  private selectedAgent: any;
  private agentLocation: any;
  private selectedAgentsGroup: any;
  private listType: any;
  private autoUpdateLocation: any;
  private poller: PollingIntervalRef;
  private interval: any;

  constructor(private $agent: $agentFactory, private $agentLocation,
              private agentRequests: AgentRequests, private $log,
              private agentsAlerts: AgentsAlerts, private bringozLoaderService: BringozLoaderService,
              private pollingIntervalService: PollingIntervalService, private $scope: IScope) {
  }

  $onInit() {
    this.searchQuery='';
    this.selectedAgentsGroup = 'Active';
    this.listType = 'taskIds';
    this.autoUpdateLocation = {
      enable: false
    };
    this.interval = 1;
  }

  onChangeEnableLocationInterval(isEnabled) {
    if (isEnabled) {
      this.poller = this.pollingIntervalService.start(this.$scope, () => {
        let lat = _.get(this.selectedAgent, 'lastKnownLocation.coordinates.latitude');
        let lng = _.get(this.selectedAgent, 'lastKnownLocation.coordinates.longitude');
        if (!!this.autoUpdateLocation.enable && lat && lng) {
          lat += 0.0002;
          lng += 0.0002;
          this.onLocationChange(lat, lng);
        }
      }, (this.interval * 1000));
    } else if (!!this.poller) {
      this.poller.cancel();
      this.poller = undefined;
    }
  }

  onChangeInterval(interval) {
    this.interval = interval;
    if (!!this.poller && this.autoUpdateLocation.enable) {
      this.poller.cancel();
      this.poller = undefined;
      this.onChangeEnableLocationInterval(this.autoUpdateLocation.enable);
    }
  }

  onAgentSelect(agent) {
    this._bindAgent(_.get(agent, 'id'));
  }

  onAgentsTabChanged(agentsGroup) {
    this.selectedAgentsGroup = agentsGroup;
    this._bindAgent(null);
  }

  onLocationChange(lat, lng) {
    this.bringozLoaderService.on();
    this.agentRequests.updateAgentLocation(this.selectedAgent.id, lat, lng)
      .then((response) => {
        this.agentsAlerts.updateSuccess();
      })
      .catch((error) => {
        this.agentsAlerts.updateError(error);
        this.$log.error('Failed to update agent location', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _bindAgent(selectedAgentId) {

    if (this.agentRef) {
      this.agentRef.$destroy();
    }

    if (this.agentLocationRef) {
      this.agentLocationRef.$destroy();
    }

    if (selectedAgentId) {
      this.agentRef = this.$agent(selectedAgentId);
      this.agentLocationRef = this.$agentLocation(selectedAgentId);

      this.agentRef.$bindCtrl(this.$scope, this, 'selectedAgent');
      this.agentLocationRef.$bindCtrl(this.$scope, this,'selectedAgentLocation');
      this.agentLocationRef.$registerOnUpdateHandler(this,(updatedLocation: LocationModel) => {

        if (_.isEqual(updatedLocation.holderId, selectedAgentId)) {
          let agentCopy = angular.copy(this.selectedAgent);
          agentCopy.lastKnownLocation = updatedLocation;
          this.selectedAgent = agentCopy;
          this.$log.debug('Updated Location:', updatedLocation);
        }

      });

    } else {
      this.selectedAgent = null;
      this.agentLocation = null;
    }
  }
  submitQuery(query){
    this.searchQuery = query
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentLocationsView', {
    bindings: {},
    template: require('./agent-locations-view.html').default,
    controller: AgentLocationsViewCtrl
  });
